import React from "react";
var Timingdata = function () {
    function isWorkingDay(date) {
        // Get the day of the week (0 = Sunday, 1 = Monday, ..., 6 = Saturday)
        var dayOfWeek = date.getDay();
        // Check if it's Sunday (0)
        if (dayOfWeek === 0) {
            return false; // Sunday, not a working day
        }
        // For other days, it's a working day
        return true;
    }
    var today = new Date();
    var isSunday = !isWorkingDay(today);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "px-3 timing-section" },
            React.createElement("div", { id: "availability-message" }, isSunday ? (React.createElement("div", { id: "non-working-day pl-3 mb-29" },
                React.createElement("div", { className: "txt_bloodRed DMSans_16_500" }, "Closed"))) : (React.createElement("div", { className: "d-flex pl-3 mb-29 gap-2" },
                React.createElement("div", { className: "txt_green DMSans_16_500" },
                    "Available Today",
                    " "),
                React.createElement("div", { className: "ml-1 basic-profile-circle imCircle" }),
                React.createElement("div", { className: "DMSans_16_500 txt_black-seven " }, "Closes today at 5:30PM")))),
            React.createElement("div", { className: "timing-data" },
                React.createElement("p", null,
                    React.createElement("span", { className: "txt_primaryGrey DMSanM_14_500" }, "Monday"),
                    React.createElement("span", { className: "DMSanM_14_500" }, "8.30 am - 5.30 pm")),
                React.createElement("p", null,
                    React.createElement("span", { className: "txt_primaryGrey DMSanM_14_500" }, "Tuesday"),
                    React.createElement("span", { className: "DMSanM_14_500" }, "8.30 am - 5.30 pm")),
                React.createElement("p", null,
                    React.createElement("span", { className: "txt_primaryGrey DMSanM_14_500" }, "Wednesday"),
                    React.createElement("span", { className: "DMSanM_14_500" }, "8.30 am - 5.30 pm")),
                React.createElement("p", null,
                    React.createElement("span", { className: "txt_primaryGrey DMSanM_14_500" }, "Thursday"),
                    React.createElement("span", { className: "DMSanM_14_500" }, "8.30 am - 5.30 pm")),
                React.createElement("p", null,
                    React.createElement("span", { className: "txt_primaryGrey DMSanM_14_500" }, "Friday"),
                    React.createElement("span", { className: "DMSanM_14_500" }, "8.30 am - 5.30 pm")),
                React.createElement("p", null,
                    React.createElement("span", { className: "txt_primaryGrey DMSanM_14_500" }, "Saturday"),
                    React.createElement("span", { className: "DMSanM_14_500" }, "10.00 am - 2.00 pm"))))));
};
export default Timingdata;
